(function () {
  'use strict';
  var NW = window.NW || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var fmt = NW.money || '${{amount}}';
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/&amp;/g, '&');
  }
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  /* ---------- announcement rotator ---------- */
  var track = $('[data-announce]');
  if (track && track.children.length > 1) {
    var ai = 0, n = track.children.length;
    setInterval(function () { ai = (ai + 1) % n; track.style.transform = 'translateY(' + (-38 * ai) + 'px)'; }, 3800);
  }

  /* ---------- mobile nav ---------- */
  var nav = $('[data-nav]');
  $$('[data-open-nav]').forEach(function (b) { b.addEventListener('click', function () { nav.classList.add('open'); nav.setAttribute('aria-hidden', 'false'); lock(true); }); });
  $$('[data-close-nav]').forEach(function (b) { b.addEventListener('click', function () { nav.classList.remove('open'); nav.setAttribute('aria-hidden', 'true'); lock(false); }); });

  /* ---------- modals ---------- */
  function openModal(name) {
    var m = $('[data-modal="' + name + '"]'); if (!m) return;
    m.classList.add('open'); m.setAttribute('aria-hidden', 'false'); lock(true);
  }
  function closeModal(m) { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); lock(false); }
  $$('[data-open-modal]').forEach(function (b) { b.addEventListener('click', function () { openModal(b.getAttribute('data-open-modal')); }); });
  $$('[data-modal]').forEach(function (m) {
    $$('[data-close-modal]', m).forEach(function (b) { b.addEventListener('click', function () { closeModal(m); if (m.getAttribute('data-modal') === 'newsletter') store.set('nw_pop', String(Date.now())); }); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-modal].open').forEach(closeModal);
    closeCart();
    if (nav) { nav.classList.remove('open'); lock(false); }
  });

  /* ---------- newsletter popup ---------- */
  var pop = $('[data-modal="newsletter"]');
  if (pop) {
    if ($('[data-pop-success]', pop)) { openModal('newsletter'); store.set('nw_pop', 'done'); }
    else {
      var last = store.get('nw_pop');
      var fresh = !last || (last !== 'done' && Date.now() - Number(last) > 3 * 864e5);
      if (fresh) {
        var shown = false;
        var show = function () { if (shown || $('.cd.open') || $('[data-modal].open')) return; shown = true; openModal('newsletter'); store.set('nw_pop', String(Date.now())); };
        setTimeout(show, 12000);
        document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) show(); });
      }
    }
  }

  /* ---------- review photos ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.rv-ph');
    if (b) {
      var m = $('[data-modal="rv-photo"]'); if (!m) return;
      $('[data-rv-lb-img]', m).src = b.getAttribute('data-full');
      $('[data-rv-lb-cap]', m).textContent = b.getAttribute('data-cap') || '';
      openModal('rv-photo'); return;
    }
    var mo = e.target.closest('[data-rv-more]');
    if (mo) { var g = $('[data-rv-grid]'); if (g) { g.classList.add('all'); $$('.rv--more', g).forEach(function (el) { el.classList.add('on'); }); } mo.remove(); }
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.rv-in').forEach(function (el) { io.observe(el); });
  } else { $$('.rv-in').forEach(function (el) { el.classList.add('on'); }); }

  /* ---------- cart drawer ---------- */
  var cd = $('[data-cart-drawer]');
  function openCart() { if (!cd) return; cd.classList.add('open'); cd.setAttribute('aria-hidden', 'false'); lock(true); }
  function closeCart() { if (!cd || !cd.classList.contains('open')) return; cd.classList.remove('open'); cd.setAttribute('aria-hidden', 'true'); lock(false); }
  $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeCart); });
  $$('[data-open-cart]').forEach(function (a) { a.addEventListener('click', function (e) { if (!cd) return; e.preventDefault(); refreshCart().then(openCart); }); });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-count', cart.item_count); });
    if (!cd) return cart;
    var body = $('[data-cd-body]', cd), foot = $('[data-cd-foot]', cd), prog = $('[data-cd-prog]', cd);
    var q = 0; cart.items.forEach(function (i) { if (i.handle === (NW.upsell && NW.upsell.handle)) q += i.quantity; });
    if (cart.item_count === 0) {
      body.innerHTML = (NW.es ? '<div class="cd__empty"><p class="h-md" style="font-family:var(--serif)">Tu carrito está vacío</p><p style="color:var(--muted)">Tu próxima prenda favorita está a un clic.</p><a class="btn" href="/es/products/the-captain">Comprar The Captain</a></div>' : '<div class="cd__empty"><p class="h-md" style="font-family:var(--serif)">Your cart is empty</p><p style="color:var(--muted)">Your next favorite layer is one click away.</p><a class="btn" href="/products/the-captain">Shop The Captain</a></div>');
      foot.hidden = true; prog.hidden = true; return cart;
    }
    foot.hidden = false; prog.hidden = false;
    var msg, pct;
    if (q >= 3) { msg = (NW.es ? '<b>Mejor precio desbloqueado:</b> $30 de descuento en tu pedido.' : '<b>Best value unlocked:</b> $30 off your order.'); pct = 100; }
    else if (q === 2) { msg = (NW.es ? '<b>Combo desbloqueado:</b> 2 por $64.90. Agrega 1 más y ahorra $30.' : '<b>Bundle unlocked:</b> 2 for $64.90. Add 1 more to save $30.'); pct = 66; }
    else { msg = (NW.es ? 'Agrega <b>1 más</b> (cualquier color) y llévate <b>2 por $64.90</b>.' : 'Add <b>1 more</b> (any color) and get <b>2 for $64.90</b>.'); pct = 33; }
    prog.innerHTML = msg + '<div class="bar"><span style="width:' + pct + '%"></span></div>';

    var html = '';
    cart.items.forEach(function (it, idx) {
      var line = idx + 1;
      var disc = (it.line_level_discount_allocations || []).reduce(function (a, d) { return a + d.amount; }, 0);
      html += '<div class="cd__line">' +
        '<img src="' + esc(it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '') + '" alt="">' +
        '<div><h3>' + esc(it.product_title) + '</h3><div class="v">' + esc(it.variant_title || '') + '</div>' +
        (disc ? '<div class="disc">' + (NW.es ? 'Descuento por combo aplicado' : 'Bundle discount applied') + '</div>' : '') +
        '<div class="qty"><button type="button" data-q="' + line + '" data-v="' + (it.quantity - 1) + '" aria-label="−">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + line + '" data-v="' + (it.quantity + 1) + '" aria-label="+">+</button></div>' +
        '<br><button class="cd__rm" type="button" data-q="' + line + '" data-v="0">' + (NW.es ? 'Quitar' : 'Remove') + '</button></div>' +
        '<div class="cd__lp">' + money(it.final_line_price) + (it.final_line_price < it.original_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + '</div>' +
        '</div>';
    });

    // upsell: other colors, same size as last item
    if (NW.upsell && NW.upsell.variants && q > 0 && q < 3) {
      var last = cart.items.filter(function (i) { return i.handle === NW.upsell.handle; })[0];
      var lastV = last && NW.upsell.variants.filter(function (v) { return v.id === last.variant_id; })[0];
      var size = lastV ? lastV.s : null;
      var inCartColors = cart.items.map(function (i) { var v = NW.upsell.variants.filter(function (x) { return x.id === i.variant_id; })[0]; return v ? v.c : null; });
      var seen = {}, opts = [];
      NW.upsell.variants.forEach(function (v) {
        if (!v.a || seen[v.c]) return;
        if (inCartColors.indexOf(v.c) > -1) return;
        var match = NW.upsell.variants.filter(function (x) { return x.c === v.c && x.s === size && x.a; })[0];
        var pick = match || v; seen[v.c] = 1; opts.push(pick);
      });
      if (opts.length) {
        html += '<div class="cd__up"><h4>' + (q === 1 ? (NW.es ? 'Agrega otro color — 2 por $64.90' : 'Add a second color — 2 for $64.90') : (NW.es ? 'Agrega un tercero — ahorra $30 en total' : 'Add a third — save $30 total')) + '</h4><div class="cd__up-row">' +
          opts.map(function (v) { return '<button type="button" data-add="' + v.id + '"><img src="' + esc(v.img) + '" alt="">' + esc(v.c) + ' · ' + esc(v.s) + '<b>' + (NW.es ? '+ Agregar' : '+ Add') + '</b></button>'; }).join('') +
          '</div></div>';
      }
    }
    body.innerHTML = html;
    var save = cart.original_total_price - cart.total_price;
    $('[data-cd-sub]', cd).textContent = money(cart.original_total_price);
    var sr = $('[data-cd-save-row]', cd); sr.hidden = save <= 0; $('[data-cd-save]', cd).textContent = '−' + money(save);
    $('[data-cd-total]', cd).textContent = money(cart.total_price);
    return cart;
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function changeLine(line, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  if (cd) {
    cd.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (b) { b.disabled = true; changeLine(Number(b.getAttribute('data-q')), Number(b.getAttribute('data-v'))); return; }
      var a = e.target.closest('[data-add]');
      if (a) { a.disabled = true; addItems([{ id: Number(a.getAttribute('data-add')), quantity: 1 }]).then(refreshCart).catch(refreshCart); }
    });
  }

  /* ---------- product page ---------- */
  var root = $('[data-product]');
  if (root) {
    var data = JSON.parse($('[data-product-json]').textContent);
    var variants = data.variants;
    var form = $('[data-product-form]', root) || $('#pdp-form');
    var idInput = $('[data-variant-id]', root);
    var qtyInput = $('[data-qty]', root);
    var atc = $('[data-atc]', root), atcLabel = $('[data-atc-label]', root), err = $('[data-atc-err]', root);
    var trackEl = $('[data-track]', root);
    var slides = $$('.gallery__slide', root);
    var thumbs = $$('[data-thumb]', root);
    var dots = $$('[data-dots] i', root);

    function goTo(i, smooth) {
      if (!trackEl || !slides[i]) return;
      trackEl.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    function currentIndex() { return Math.round(trackEl.scrollLeft / trackEl.clientWidth); }
    if (trackEl) {
      var st; trackEl.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { setActive(currentIndex()); }, 60); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-thumb'))); }); });
      var prev = $('[data-prev]', root), next = $('[data-next]', root);
      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, currentIndex() - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, currentIndex() + 1)); });
    }

    function selected(name) { var el = $('input[name="' + name + '"]:checked', root); return el ? el.value : null; }
    function findVariant(c, s) { return variants.filter(function (v) { return v.o1 === c && v.o2 === s; })[0]; }

    function updateSizes(color) {
      $$('[data-size]', root).forEach(function (box) {
        var s = box.getAttribute('data-size');
        var v = findVariant(color, s);
        var ok = v && v.available;
        box.classList.toggle('na', !ok);
        $('input', box).disabled = !ok;
      });
      var cur = selected('opt-size');
      var cv = findVariant(color, cur);
      if (!cv || !cv.available) {
        var first = variants.filter(function (v) { return v.o1 === color && v.available; })[0];
        if (first) { var inp = $('input[name="opt-size"][value="' + first.o2 + '"]', root); if (inp) inp.checked = true; }
      }
    }

    var bundleOff = 0, bundleQty = 1;
    function update(scrollMedia) {
      var c = selected('opt-color'), s = selected('opt-size');
      var v = findVariant(c, s);
      var cl = $('[data-color-label]', root); if (cl) cl.textContent = c || '';
      if (!v) { atc.disabled = true; atcLabel.textContent = NW.es ? 'No disponible' : 'Unavailable'; return; }
      idInput.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? (bundleQty > 1 ? (NW.es ? 'Agregar ' + bundleQty + ' al carrito — ' : 'Add ' + bundleQty + ' to cart — ') + money(v.price * bundleQty - bundleOff) : (NW.es ? 'Agregar al carrito' : 'Add to cart')) : (NW.es ? 'Agotado' : 'Sold out');
      $('[data-price]', root).textContent = money(v.price);
      var bp1 = $('[data-bp="1"]', root); if (bp1) bp1.textContent = money(v.price);
      var meta = $('[data-sticky-meta]'); if (meta) meta.textContent = v.title + ' · ' + money(v.price);
      if (scrollMedia && v.media) {
        var idx = slides.findIndex ? slides.findIndex(function (sl) { return Number(sl.getAttribute('data-media-id')) === v.media; }) : -1;
        if (idx > -1) goTo(idx);
      }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); u.searchParams.delete('variant_color'); history.replaceState({}, '', u.toString()); }
    }

    $$('input[name="opt-color"]', root).forEach(function (i) { i.addEventListener('change', function () { updateSizes(i.value); update(true); }); });
    $$('input[name="opt-size"]', root).forEach(function (i) { i.addEventListener('change', function () { update(false); }); });
    $$('input[name="bundle"]', root).forEach(function (i) {
      i.addEventListener('change', function () { bundleQty = Number(i.value); bundleOff = Number(i.getAttribute('data-off')); qtyInput.value = bundleQty; update(false); });
    });

    // preselect from ?variant_color=
    var qc = new URLSearchParams(location.search).get('variant_color');
    if (qc) { var ci = $('input[name="opt-color"][value="' + qc + '"]', root); if (ci) ci.checked = true; }
    updateSizes(selected('opt-color')); update(!!qc);

    // delivery estimate (business days)
    function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
    var eta = $('[data-eta]', root);
    if (eta) {
      var now = new Date(), f = { month: 'short', day: 'numeric' };
      try { eta.textContent = addBiz(now, 4).toLocaleDateString('en-US', f) + ' – ' + addBiz(now, 9).toLocaleDateString('en-US', f); } catch (e) {}
    }

    function submit(e) {
      if (e) e.preventDefault();
      var v = Number(idInput.value); if (!v) return;
      err.hidden = true; atc.disabled = true; var old = atcLabel.textContent; atcLabel.textContent = NW.es ? 'Agregando…' : 'Adding…';
      addItems([{ id: v, quantity: bundleQty }]).then(function () {
        atcLabel.textContent = old; atc.disabled = false;
        return refreshCart().then(openCart);
      }).catch(function (j) {
        atcLabel.textContent = old; atc.disabled = false;
        err.textContent = (j && (j.description || j.message)) || (NW.es ? 'Algo salió mal. Inténtalo de nuevo.' : 'Something went wrong. Please try again.'); err.hidden = false;
      });
    }
    if (form) form.addEventListener('submit', submit);

    // sticky add to cart
    var sticky = $('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var below = e.boundingClientRect.top < 0;
          var show = !e.isIntersecting && below;
          sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      });
      so.observe(atc);
      $('[data-sticky-btn]').addEventListener('click', function () {
        if (atc.disabled) { root.scrollIntoView({ behavior: 'smooth' }); return; }
        submit();
      });
    }

    if (location.hash === '#size-guide') openModal('size-guide');
  }

  // make sure the count is right if the page was cached
  if (cd && document.visibilityState) { document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshCart(); }); }
})();
